import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import {
  DealerNetwork,
  IconContainer,
  NetworkName
} from '../DealerInfo/Styles';
import Icon from '../../../../../_shared/components/Icon';
import { NetworkVariant } from '../../../../../_shared/types/trade';

const propTypes = {
  variant: PropTypes.oneOf([NetworkVariant.ACTIVE, NetworkVariant.PENDING]),
  hasNetworkLabel: PropTypes.bool
};

const defaultProps = {
  variant: NetworkVariant.ACTIVE,
  hasNetworkLabel: false
};

const NetworkInfo = ({ displayName, variant, hasNetworkLabel }) => {
  const getNetworkName = () => {
    // Default state is "Network someDGNname"
    let messageId = 'list.card.dgn.network';

    // "Network Star Dealer Group Network (Duplicate in Open network)"
    if (variant === NetworkVariant.PENDING) {
      messageId = hasNetworkLabel
        ? 'list.card.dgn.network'
        : 'list.card.dgn.pending.network';
    }

    return (
      <NetworkName variant={variant}>
        <FormattedMessage
          id={messageId}
          values={{
            networkName: displayName
          }}
        />
      </NetworkName>
    );
  };
  return (
    <DealerNetwork>
      <IconContainer>
        <Icon icon="TR5-GroupNetwork" />
      </IconContainer>
      {getNetworkName()}
    </DealerNetwork>
  );
};

NetworkInfo.propTypes = propTypes;
NetworkInfo.defaultProps = defaultProps;

export default NetworkInfo;
